import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}

export function EmptyState({ icon, title, description, action, className }: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-4 rounded-2xl border border-dashed border-[var(--color-border-default)] bg-[var(--color-bg-surface)] p-12 text-center',
        className,
      )}
    >
      {icon && (
        <div className="flex h-14 w-14 items-center justify-center rounded-full bg-[var(--color-bg-elevated)] text-[var(--color-fg-muted)]">
          {icon}
        </div>
      )}
      <div className="space-y-1">
        <h3 className="text-base font-bold text-[var(--color-fg-primary)]">{title}</h3>
        {description && (
          <p className="text-sm text-[var(--color-fg-muted)] max-w-md">{description}</p>
        )}
      </div>
      {action}
    </div>
  );
}
